import { Card, CardBody, Col } from "reactstrap";
import { EffectCoverflow, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../AbstractElements";
import { EffectCoverflowTitle } from "../../../Constants/Constants";
import { EffectCoverflowSubTitle } from "../../../Data/BonusUi/Carousel";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const EffectCoverflowSlider = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={EffectCoverflowTitle} span={EffectCoverflowSubTitle} />
        <CardBody>
          <Swiper effect={"coverflow"} loop={true} grabCursor={true} centeredSlides={true} slidesPerView={"auto"} coverflowEffect={{ rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true }} pagination={true} modules={[EffectCoverflow, Pagination]} className="mySwiper coverflow-slider">
            {dynamicNumber(10).map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(`slider/${item + 1}.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EffectCoverflowSlider;
